/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessage2Code = createReactComponent("message-2-code", "IconMessage2Code", [
  ["path", { d: "M8 9h8", key: "svg-0" }],
  ["path", { d: "M8 13h6", key: "svg-1" }],
  [
    "path",
    {
      d: "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6",
      key: "svg-2"
    }
  ],
  ["path", { d: "M20 21l2 -2l-2 -2", key: "svg-3" }],
  ["path", { d: "M17 17l-2 2l2 2", key: "svg-4" }]
]);

export { IconMessage2Code as default };
//# sourceMappingURL=IconMessage2Code.js.map
